import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ReglementPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-main)', paddingTop: '80px' }}>
      <section style={{ padding: '3rem 1.2rem 2rem', background: 'var(--gradient-hero)', textAlign: 'center' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <Link to="/" className="body-small" style={{ textDecoration: 'none', color: 'var(--text-secondary)', display: 'inline-flex', alignItems: 'center', gap: '0.5rem', marginBottom: '2rem' }}>
            <ArrowLeft size={16} /> Retour
          </Link>
          <h1 className="heading-hero" style={{ marginBottom: '1rem' }}>Règlement Intérieur</h1>
        </div>
      </section>

      <section style={{ padding: '3rem 1.2rem' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>1. Objet et champ d'application</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Le présent règlement intérieur s'applique à tous les candidats inscrits sur la plateforme <strong>VAE Accompagnement</strong> d'APDR de la VAE, quelle que soit la formule choisie (Bronze, Silver, Gold ou Kit par bloc).<br /><br />
              Il a pour objet de définir les règles de fonctionnement et de discipline applicables dans le cadre de l'accompagnement VAE.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>2. Accès à la plateforme</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              L'accès à la plateforme e-learning est personnel et non cessible. Chaque candidat dispose d'un identifiant et d'un mot de passe strictement confidentiels.<br /><br />
              Il est interdit de partager ses identifiants de connexion avec des tiers ou de permettre l'accès à son compte à une autre personne.<br /><br />
              Tout partage, reproduction ou diffusion des contenus pédagogiques (cours, quiz, supports, Livret 2 annoté) est formellement interdit et pourra entraîner la résiliation immédiate de l'accès sans remboursement.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>3. Séances d'accompagnement</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Les séances d'accompagnement se déroulent en visioconférence aux dates et heures convenues.<br /><br />
              <strong>Ponctualité :</strong> Le candidat s'engage à être ponctuel. Tout retard de plus de 15 minutes sans prévenir entraîne l'annulation de la séance, qui sera décomptée du forfait.<br /><br />
              <strong>Annulation/Report :</strong> Toute annulation ou demande de report doit être effectuée au minimum 24 heures à l'avance via la plateforme. À défaut, la séance sera considérée comme consommée.<br /><br />
              <strong>Absences répétées :</strong> En cas d'absences répétées non justifiées, APDR de la VAE se réserve le droit de suspendre l'accompagnement.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>4. Corrections du Livret 2</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Les corrections sont réalisées dans un délai raisonnable à compter de la réception du document du candidat.<br /><br />
              Le candidat s'engage à envoyer ses travaux dans les délais convenus avec l'accompagnateur afin de garantir le bon déroulement de l'accompagnement.<br /><br />
              Les corrections et retours sont destinés à l'usage exclusif du candidat et ne peuvent être partagés.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>5. Comportement et respect mutuel</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Les échanges entre le candidat et l'accompagnateur doivent se faire dans le respect mutuel, la courtoisie et la bienveillance.<br /><br />
              Tout comportement inapproprié, irrespectueux ou abusif pourra entraîner l'exclusion immédiate de la plateforme sans remboursement.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>6. Engagements du candidat</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Le candidat s'engage à :<br /><br />
              - Fournir un travail personnel et original dans la rédaction de son Livret 2<br />
              - Ne pas utiliser d'outils de génération de texte par intelligence artificielle pour la rédaction de son dossier<br />
              - Respecter les échéances et le calendrier d'accompagnement<br />
              - Informer l'accompagnateur de tout changement de situation pouvant affecter son parcours
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>7. Sanctions</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              En cas de manquement aux dispositions du présent règlement, APDR de la VAE se réserve le droit de :<br /><br />
              - Adresser un avertissement écrit au candidat<br />
              - Suspendre temporairement l'accès à la plateforme<br />
              - Résilier définitivement l'inscription sans remboursement en cas de manquement grave ou répété
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>8. Contact</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Pour toute question relative au présent règlement intérieur :<br /><br />
              Email : <a href="mailto:apdr.vae@gmail.com">apdr.vae@gmail.com</a><br />
              Téléphone : 06 88 39 96 24
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReglementPage;
